import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLazyQuery } from '@apollo/client'
import { GET_BOAT_SEAT_LAYOUT } from 'graphql/route/queries'

export function SeatLayoutDropdown({ fields, onChangeData, disabled = false }) {
    const { t } = useTranslation()

    const [seatLayoutList, setSeatLayoutList] = useState([])

    const [getSeatLayoutList, { loading: seatLayoutLoading, error: seatLayoutError }] = useLazyQuery(
        GET_BOAT_SEAT_LAYOUT,
        {
            fetchPolicy: 'network-only',
            notifyOnNetworkStatusChange: true,
            onCompleted: data => {
                if (data.boatSeatLayout) {
                    // The API returns a single layout or all layouts when id is null
                    // Wrap in array if single object returned
                    const layouts = Array.isArray(data.boatSeatLayout) 
                        ? data.boatSeatLayout 
                        : [data.boatSeatLayout]
                    setSeatLayoutList(layouts.filter(layout => layout !== null))
                }
            },
        }
    )

    // Get Seat Layout List
    const getSeatLayouts = () => {
        getSeatLayoutList({
            variables: {
                boatSeatLayoutId: null,
            },
        })
    }

    useEffect(() => {
        getSeatLayouts()
    }, [])

    const onChangeHandler = e => {
        console.log('Seat Layout selected--', e.target.value)
        // Set the value to the form
        fields.onChange(e)
        // Find the selected item
        const selectedItem = seatLayoutList.find(item => item.layout_id === e.target.value)
        console.log('Selected Seat Layout--', selectedItem)
        if (selectedItem && onChangeData) {
            onChangeData(selectedItem)
        }
    }

    return (
        <>
            {seatLayoutLoading && <div className="flex justify-center items-center bg-white py-5">{t('Loading')} ....</div>}
            {seatLayoutError && (
                <div className="flex justify-center items-center bg-white py-5">
                    <div className="text-lg text-center">{t('Failed to fetch seat layouts')}</div>
                </div>
            )}
            {!seatLayoutLoading && !seatLayoutError && seatLayoutList?.length === 0 && (
                <div className="flex justify-center items-center bg-white py-5">
                    <div className="text-lg text-center">{t('No seat layouts found!')}</div>
                </div>
            )}
            {!seatLayoutLoading && !seatLayoutError && seatLayoutList?.length > 0 && (
                <select
                    {...fields}
                    disabled={disabled}
                    onChange={onChangeHandler}
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:max-w-full sm:text-sm sm:leading-6 disabled:bg-gray-100 disabled:cursor-not-allowed"
                >
                    <option value="">{t('Select a Seat Layout')}</option>
                    {seatLayoutList.map(layout => (
                        <option key={layout.layout_id} value={layout.layout_id}>
                            {layout.description?.en || layout.layout_key} ({layout.num_rows}x{layout.num_columns})
                        </option>
                    ))}
                </select>
            )}
        </>
    )
}

SeatLayoutDropdown.propTypes = {
    fields: PropTypes.object.isRequired,
    onChangeData: PropTypes.func,
    disabled: PropTypes.bool,
}
